module.exports = __webpack_public_path__ + "img/display.aab03102.svg";